import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

type GenerateDescriptionResponse = string;

export function useGenerateDescription() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      agentUuid,
    }: {
      agentUuid: string;
    }): Promise<GenerateDescriptionResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/generate_description`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid }),
        }
      );

      const data = await response.json();

      return data?.data?.content || '';
    },
  });
}
